import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';

export class NotificationHistory extends BaseEntityModel {
  /**
   * @var {number}
   */
  id;

  /**
   * @var {string}
   */
  modelType;

  /**
   * @var {number}
   */
  modelId;

  /**
   * @var {string}
   */
  type;

  /**
   * @var {number}
   */
  userId;

  /**
   * @var {number}
   */
  estateId;

  constructor(model = {}) {
    super(model);

    this.id = model.id;
    this.modelType = model.modelType;
    this.modelId = model.modelId;
    this.type = model.type;
    this.userId = model.userId;
    this.estateId = model.estateId;
  }
}
